import { Config } from "@config";
import { AbstractSubmitStep } from "@component/assets/AbstractLeadForm/Steps/AbstractSubmitStep";
import { FormIncomeSimple, ProgressButton } from "bm-ui-kit";
import type { FormIncomeSimpleData } from "bm-ui-kit";
import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import React from "react";
import { Card } from "react-bootstrap";

export interface StepFields {
	incomeList?: FormIncomeSimpleData[];
}

export class Step2 extends AbstractSubmitStep<StepFields> {
	protected renderContent(_values: StepFields, form: FormApi<StepFields>): ReactNode {
		const { submitState } = this.props;
		const disabled = this.isDisabled();

		return (
			<>
				<Card.Body>
					<FormIncomeSimple
						name="incomeList"
						label="Jövedelem"
						apiAddress={Config.getApiUrl("/api/public/bank/loan/personal-loan/income-types")}
						size="sm"
						withReceiptAmount
						withIncomeStart
						validate={FormIncomeSimple.validateIncomeList}
						disabled={disabled}
						required
					/>
				</Card.Body>
				<Card.Footer className="text-center">
					<ProgressButton
						type="submit"
						state={submitState}
						className={!form.getState().valid ? "disabled" : ""}
					>
						Legjobb ajánlat mutatása
					</ProgressButton>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "Step2";
	}
}
